export default __webpack_public_path__ + "static/media/icon-menu.10428d4a.svg";